import { render, staticRenderFns } from "./header-content.vue?vue&type=template&id=56ebfed0&"
import script from "./header-content.vue?vue&type=script&lang=js&"
export * from "./header-content.vue?vue&type=script&lang=js&"
import style0 from "./header-content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports